import { render, staticRenderFns } from "./adTemp.vue?vue&type=template&id=12cf9ed8&scoped=true&"
import script from "./adTemp.vue?vue&type=script&lang=js&"
export * from "./adTemp.vue?vue&type=script&lang=js&"
import style0 from "./adTemp.vue?vue&type=style&index=0&id=12cf9ed8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12cf9ed8",
  null
  
)

export default component.exports